export const BRAND = {
  name: "Water System Bros.",
  city: "San Diego",
  phone: "(858) 123-4567",
  phoneHref: "tel:+18581234567",
  email: "info@watersystembros.com",
  hours: "Mon – Fri, 8AM – 5PM",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Learn About Your Water", to: "/learn" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "About Us", to: "/about" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

export const INTERESTS = ["Whole Home Water Filtration", "Under Sink Reverse Osmosis", "Water Testing Only", "General Information"];

export const TIMES = ["8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM"];

export const PRODUCTS = {
  tank: {
    id: "fst-tank",
    brand: "Water System Bros.",
    name: "WS9 Series Water Filtration System",
    variant: "Tank Only",
    price: "$1,299.00",
    images: ["/img/tank.jpg", "/img/valve.jpg"],
    text: "The WS9 Series is a high performance water filtration system designed to reduce chlorine, chloramine, and other contaminants, providing cleaner, better-tasting water throughout your home. This listing is for the tank only.",
  },
  cartridge: {
    id: "fst-cartridge",
    brand: "Water System Bros.",
    name: "WS9 Series GACC Catalytic Cartridge",
    variant: "0.5 CBFT",
    price: "$199.00",
    images: ["/img/cartridge.jpg"],
    text: "The WS9 Series GACC Catalytic Cartridge is designed to reduce chlorine, chloramine, and other contaminants, keeping your water clean and great-tasting. For optimal performance, the cartridge should be replaced every 12 months.",
  },
};

export const PROCESS = [
  { n: "01", title: "Get in touch", text: "Sign up and we'll reach out to schedule a visit." },
  { n: "02", title: "In-home consultation", text: "We assess your home and recommend the right solution." },
  { n: "03", title: "Professional installation", text: "Our team sets everything up and ensures it's running properly." },
  { n: "04", title: "Enjoy cleaner water", text: "Better-tasting water for you and your family." },
];

export const FAQS = [
  { q: "What does the WS9 Series system do?", a: "It filters water for your whole home, reducing chlorine, chloramine, and other contaminants so every tap delivers cleaner, better-tasting water." },
  { q: "How often does the cartridge need replacing?", a: "For optimal performance, the WS9 Series GACC Catalytic Cartridge should be replaced every 12 months." },
  { q: "Do you install it for me?", a: "Yes. We come to you, assess your home, and our team handles the professional installation from start to finish." },
  { q: "What areas do you serve?", a: "We serve homeowners throughout San Diego. Sign up and we'll confirm coverage for your address." },
  { q: "How long does installation take?", a: "[Add typical install time here.]" },
];
